import { WSQueryCache } from "@ws-react-query";
import { applyWSTheme } from "@wingspanhq/fe-component-library";
import {
  initClient,
  initMember
} from "../../../components/App/useInitMemberApp";
import { useWSMutation } from "../../../query/helpers";
import { QUERY_CUSTOMIZATION } from "../../../query/customization/keys";
import { QUERY_USERS_SESSION } from "../../../query/session";
import { QUERY_USERS_USER_PROFILE } from "../../../query/users/keys";
import { getCustomization } from "../../../services/customizations/getCustomization";
import {
  pullSessionToken,
  pushSessionToken
} from "../../../services/sessionStorage";
import { usersService } from "../../../services/users";
import {
  requestAuthTokenFromParent,
  sendMessageToParent
} from "../utils/postMessage";

export const useInitEmbeddedApp = () =>
  useWSMutation(
    async () => {
      const token = await requestAuthTokenFromParent();
      pushSessionToken(token);

      const session = await usersService.session.get();
      WSQueryCache.setQueryData(QUERY_USERS_SESSION, session);

      const userId = session.userId;

      if (!userId) {
        throw new Error("Session does not contain a user ID");
      }

      const user = await usersService.user.get(userId);
      WSQueryCache.setQueryData(QUERY_USERS_USER_PROFILE, user);

      await Promise.all([initMember(userId), initClient(userId)]);

      try {
        const customization = await getCustomization();
        window.organizationAccountConfig = customization;
        WSQueryCache.setQueryData([QUERY_CUSTOMIZATION], customization);
        if (customization.appearance) {
          applyWSTheme(customization.appearance);
        }
      } catch {
        // Customization is non-critical for embedded app initialization
      }
    },
    {
      onError: () => {
        sendMessageToParent("error", {
          message: "Failed to initialize embedded app"
        });
      }
    }
  );
